import React from 'react'
import { useSelector } from 'react-redux'
import constants from '../../../constants'
import { Button } from 'reactstrap'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import addlIcon from '../../../assests/images/add-white-icon.svg'
// import PropTypes from 'prop-types'

function AdminContestHeader (props) {
  const adminData = useSelector(state => state.auth.adminData)

  const permission = (adminData.aPermissions && adminData.aPermissions.length && adminData.aPermissions.find(e => e.eKey === 'CMS').eType) ? adminData.aPermissions.find(e => e.eKey === 'CMS').eType : adminData.eType === 'SUPER' ? constants.WRITE_PERMISSION : constants.NO_PERMISSION

  return (
    <div className="header-block">
      <div className="filter-block d-flex justify-content-between align-items-start">
        <h2>Admin Contest Management</h2>
        {/* <div className="btn-list">
          {permission === constants.WRITE_PERMISSION
            ? (
            <Button tag={Link} to="/cms/cms-management/addcms" className="theme-btn icon-btn">
              <img src={addlIcon} alt="add" />
              Add Contest
            </Button>
              )
            : null }
        </div> */}
      </div>
    </div>
  )
}
AdminContestHeader.propTypes = {

}
export default AdminContestHeader
